import { GivelifyRadio } from '@givelify/givelify-ui';
import {
    DesignTokens,
    GivelifyAutocomplete,
    GivelifyLabel,
} from '@givelify/ui';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StepRoot = styled('div')({
    maxWidth: 688,
});

export const StepHeader = styled(GivelifyLabel)(({ theme }) => ({
    color: theme.legacy.colors.neutralGrey,
    marginBottom: 32,
}));

export const AllFieldText = styled(GivelifyLabel)(({ theme }) => ({
    color: theme.legacy.colors.neutralGrey,
    fontSize: 12,
    lineHeight: '20px',
    marginBottom: 8,
}));

export const MarginBottom16 = styled(GivelifyLabel)({
    marginBottom: 16,
});

export const FirstNameBlock = styled(Grid)({
    paddingRight: 8,
});

export const LastNameBlock = styled(Grid)({
    paddingLeft: 8,
});

export const DetailRow = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
    color: theme.legacy.colors.primaryDarkGray,
}));

export const PermissionCardGrid = styled(Grid)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

export const CardContent = styled('div')<{
    selected?: boolean;
    disabled?: boolean;
}>(({ theme, selected, disabled }) => ({
    width: '100%',
    maxWidth: 336,
    background: '#FFFFFF',
    boxShadow: '0px 0px 8px rgba(152, 162, 173, 0.4)',
    borderRadius: '10px',
    cursor: disabled ? 'default' : 'pointer',
    border: selected ? '1px solid #715AFF' : '1px solid transparent',
    filter: selected
        ? 'drop-shadow(0px 0px 8px rgba(152, 162, 173, 0.4))'
        : 'none',
    '& *': disabled
        ? {
              color: DesignTokens.color.textDisabled,
          }
        : {},
}));

export const CardTitleContent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 32,
});

export const DetailContent = styled('div')({
    height: 336,
    padding: '0px 24px',
    '@media (max-width: 860px)': {
        height: 380,
    },
    '@media (max-width: 760px)': {
        height: 400,
    },
    '@media (max-width: 700px)': {
        height: 425,
    },
});

export const DetailText = styled('div')(({ theme }) => ({
    fontSize: 16,
    color: theme.legacy.colors.primaryDarkGray,
}));

export const CardFooter = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    background: theme.legacy.colors.neutralHoverGrey,
    borderTop: '1px solid #D8D8D8',
    borderRadius: '0px 0px 10px 10px',
}));

export const RadioButton = styled(GivelifyRadio)<{ selected?: boolean }>(
    ({ selected }) => ({
        padding: selected ? '4.5px 0px' : '5.5px 0px',
    }),
);

export const CheckIcon = styled('div')({
    marginRight: 12,
});

export const TitleSelect = styled(GivelifyAutocomplete)({
    '& .MuiOutlinedInput-input': {
        height: '15px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: 0,
    },
    '& .MuiFormControl-root .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
        transform: 'translate(14px, 13px)',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        background: '#FFFFFF',
        padding: '0px 8px',
    },
});

export const TitleSelectHelperText = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 26,
});

export const EmailBox = styled(Grid)({
    '& .MuiStack-root': {
        paddingLeft: 0,
    },
});
